// Copyright (c) 2016 Deere & Company

import React, {PropTypes} from 'react';
import {FormattedMessage} from 'react-intl';

const SettingsHeader = props =>
    <section className={props.className}>
        <h2 className='title'>
            <FormattedMessage id={props.title}/>
        </h2>
        <button
            className='save'
            disabled={props.isSaveDisabled}
            onClick={props.onSave}
            type='button'
        >
            <FormattedMessage id='SAVE'/>
        </button>
    </section>;

SettingsHeader.displayname = 'SettingsHeader';
SettingsHeader.propTypes = {
    className: PropTypes.string.isRequired,
    isSaveDisabled: PropTypes.bool,
    onSave: PropTypes.func.isRequired,
    title: PropTypes.string.isRequired
};

export default SettingsHeader;



// WEBPACK FOOTER //
// ./src/user/shared/components/settings-header/index.js